
import React from 'react';
import { Link } from 'react-router-dom';

const QuoteSection = ({ homeContent }) => {
  return (
    <div>
      {/* Improve Your Business CTA Section */}
      <section className="cta-wrapper cta--four bgimage biz_overlay overlay--secondary">
        <div
          className="bg_image_holder"
          style={{
            backgroundImage: 'url("/images/cbg2.webp")',
            opacity: 1,
          }}
        >
          <img src="img/cbg2.jpg" alt="Background" />
        </div>

        <div className="content_above px-3 px-md-5">
          <div className="row">
            <div className="col-lg-12">
              <div className="cta-content text-center">
                <h1 className="display-3">
                  Improve Your Business With Us
                </h1>
              </div>
            </div>

            <div className="col-lg-8 offset-lg-2">
              <div className="cta-content text-center">
                <p>
                  {homeContent?.home_cta_section ||
                    'Default about text'}
                </p>

                <span className="phone">
                  <i className="la la-headphones"></i>
                  {' '}
                  {homeContent?.home_cta_mobile_number ||
                    'Default Mobile : 8012345678'}
                </span>

                <Link
                  to="/contact"
                  className="btn btn-primary btn-lg btn-icon icon-left"
                  style={{ cursor: 'pointer' }}
                >
                  <i className="la la-envelope"></i>
                  {' '}
                  Send Message
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Valuable Ideas, Experience and Budget Section */}
      <section className="p-top-50 p-bottom-15">
        <div className="icon-boxes icon-box--four">
          <div className="px-3 px-md-5">
            <div className="row">

              {/* Valuable Ideas */}
              <div className="col-lg-4 col-md-6">
                <div className="icon-box-four d-flex">
                  <div className="box-icon">
                    <span className="icon-rounded-sm">
                      <i className="la la-thumbs-up"></i>
                    </span>
                  </div>

                  <div className="box-content">
                    <h6>Valuable Ideas</h6>
                    <p>
                      {homeContent?.home_valuable_ideas ||
                        'Valuable ideas description'}
                    </p>
                  </div>
                </div>
              </div>

              {/* Industry Experience */}
              <div className="col-lg-4 col-md-6">
                <div className="icon-box-four d-flex">
                  <div className="box-icon">
                    <span className="icon-rounded-sm">
                      <i className="la la-bar-chart"></i>
                    </span>
                  </div>

                  <div className="box-content">
                    <h6>Industry Experience</h6>
                    <p>
                      {homeContent?.home_industry_experience ||
                        'Industry experience description'}
                    </p>
                  </div>
                </div>
              </div>

              {/* Budget Friendly */}
              <div className="col-lg-4 col-md-6">
                <div className="icon-box-four d-flex">
                  <div className="box-icon">
                    <span className="icon-rounded-sm">
                      <i className="la la-money"></i>
                    </span>
                  </div>

                  <div className="box-content">
                    <h6>Budget Friendly</h6>
                    <p>
                      {homeContent?.budget_friendly || 'Budget'}
                    </p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default QuoteSection;